(function(a) {
    (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
})(navigator.userAgent || navigator.vendor || window.opera);
(function($) {
    'use strict';

    function transitionEnd() {
        var el = document.createElement('bootstrap');

        var transEndEventNames = {
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'oTransitionEnd otransitionend',
            'transition': 'transitionend'
        };

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return { end: transEndEventNames[name] };
            }
        }

        return false;
    }

    $.fn.emulateTransitionEnd = function(duration) {
        var called = false;
        var $el = this;
        $(this).one('bsTransitionEnd', function() { called = true })
        var callback = function() {
            if (!called) $($el).trigger($.support.transition.end)
        }
        setTimeout(callback, duration)
        return this
    }

    $(function() {
        $.support.transition = transitionEnd();
        if (!$.support.transition) return

        $.event.special.bsTransitionEnd = {
            bindType: $.support.transition.end,
            delegateType: $.support.transition.end,
            handle: function(e) {
                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
            }
        }
    })

    // MODAL CLASS DEFINITION
    // ======================

    var Modal = function(element, options) {

        this.options = options;
        this.$window = $(window);
        this.$body = $(document.body);
        this.$element = $(element);
        this.$dialog = this.$element.find('.modal-dialog');
        this.$backdrop = null;
        this.$contents = $(element).find('.modal-content');
        this.$ctnBody = this.$contents.children('.modal-body').length > 0 ? this.$contents.children('.modal-body') : this.$contents.children('iframe');
        this.$ctnFoot = this.$contents.children('.modal-footer');
        this.$iframe = this.$ctnBody.is('iframe') ? this.$ctnBody : null;
        this.iframe = this.$iframe ? this.$iframe.get(0) : null;
        this.iframeContent = this.iframe ? this.iframe.contentWindow : null;
        this.iframeMode = this.iframeMode = this.options.iframe && this.options.iframe.length > 0 && !!this.$iframe; 
        this.isMove = (this.$contents.length > 1) ? true : false;
        this.isShown = null;
        this.remoteFirstLoaded = null;
        this.isLoadingIframe = false;
        this.isWaitforSwitch = false;
        this.originalBodyPad = null;
        this.scrollbarWidth = 0;
        this.ignoreBackdropClick = false;
        this.isloading = false;
        this.switchIframeStatus = {action:'', direction:''};
        this.iframePostEvents = function(e) {
            var self = this ;
            var action = e.data.replace(/(^[\w-]+)(\?.+)/, '$1');
            var params = e.data.replace(/[\w-]+(\?)(.+)/, '$2').split("&").map(function(n) {
                n = n.split("=");
                this[n[0]] = n[1];
                if (Object.keys(this).length > 0 && function(obj) {
                        var arr = [];
                        for (var key in obj) {
                            arr.push(obj[key]);
                        }
                        return arr;
                    }(this).indexOf(undefined) === -1) {
                    return this;
                } else {
                    return null;
                }
                return Object.keys(this).length > 0 ? this : null;
            }.bind({}))[0];
            console.log(
                // 'top.location.href:', top.location.href,
                'action:', action,
                '\nparams:', params
            );
            var $iframe = this.$contents.find('iframe:first-child').get(0);
            switch (action) {
                case "close":
                    this.hide();
                break;
                case "hello":
                    if ( $.type(this.options.iframeSendToChild.hello) === 'object' ) {
                        $iframe.contentWindow.postMessage( 'yes?' + $.param(this.options.iframeSendToChild.hello) ,  "*" );
                    } else {
                        $iframe.contentWindow.postMessage( 'yes?docWidth=' + document.documentElement.clientWidth ,  "*" );
                    }
                break;
                case "load":
                    if (!params.hasOwnProperty("height")) {
                        console.log("fix height without height value");
                    } else {
                        if ( !params.hasOwnProperty("nthIframe") || params.nthIframe === 'undefined' ) {
                            params.nthIframe = 1;
                        }
                        fixIframeHeight(params.target, ['#email-modify', '#verif-phone', '#bind-3party', '#unbind-3party', '#pass-modify'].indexOf(params.target) !== -1 ? parseInt(params.height) + 10 : params.height, params.nthIframe);
                        this.isLoadingIframe = false;
                        if ( this.isWaitforSwitch ) {
                        	switchIframe.call(this, params.target, this.switchIframeStatus.action, this.switchIframeStatus.direction);
                        	this.isWaitforSwitch = false;
                        }
                    }
                break;
                case "check":
                    if (params.hasOwnProperty("height")) {
                        fixIframeHeight(params.target, params.height, "active");
                    }
                break;
                case "prev":
                case "next":
                    if (!params.hasOwnProperty("iframeUrl")) {
                        console.log("append without url")
                    } else {
                        this.isLoadingIframe = true;
                        if (!params.hasOwnProperty("direction")) {
	                        params.direction = "horizontal";
	                    } 
	                    appendIframe(action, params.target, params.iframeUrl, params.direction);
	                    this.switchIframeStatus.action = action;
	                    this.switchIframeStatus.direction = params.direction;
	                    this.isWaitforSwitch = true;
                    }
                break;
                default: break;
            }

            function fixIframeHeight(target, height, nthIframe) {
                console.log(target, height, nthIframe);
                if ( $(target).length === 0 ) {
                    target = self.$element.get(0);
                }
                if ( typeof nthIframe === 'undefined' ) {
                    var nthIframe = 1;
                }
                if ( typeof nthIframe === 'string' && nthIframe == 'active') {
                    var $iframe = $(target).find(".modal-content").find('iframe.active');
                } else {
                    var $iframe = $(target).find(".modal-content").find('iframe:nth-child(' + nthIframe + ')');
                }
                $iframe.css("height", parseInt(height));
            }

            function appendIframe(action, target, content, direction) {
                var slideInClass = '';
                var $iframe = $(target).find('iframe.active');
                switch (action) {
                	case 'prev':  
                		$iframe = $iframe.prev('iframe');
                		if (direction == 'horizontal') { slideInClass = 'left'; }
                		else if (direction == 'vertical') { slideInClass = 'top' };
	                break;
                	case 'next':
                		$iframe = $iframe.next('iframe');
                		if (direction == 'horizontal') { slideInClass = 'right'; }
                		else if (direction == 'vertical') { slideInClass = 'bottom' };
	                break;
	                default: break;
                } 
                $iframe.addClass(slideInClass);
                $iframe.attr("src", content);
                $iframe.attr("scrolling", "no");
                $iframe.css({'display': 'block', 'visibility': 'hidden' });
            }

            function switchIframe(target, action, direction) {
                if ((direction == 'horizontal' || direction == 'vertical') && (action == 'prev' || action == 'next')) {
                    var $content = $(target).find('.modal-content');
                    var $iframes = $(target).find('iframe');
                    var $currentIframe = $(target).find('iframe.active');
                    var $nextIframe = $currentIframe;
                    var $placeholder = $('<div class="holder"></div>');
                    var slideOutClass = '';
                    var slideInClass = '';
                    var slideOutTop = 0;
                    switch (action) {
                        case 'prev':
                            $nextIframe = $nextIframe.prev('iframe');
                            if (direction == 'horizontal') {
                                slideOutClass = 'right';
                                slideInClass = 'left';
                            } else if (direction == 'vertical') {
                                slideOutClass = 'bottom';
                                slideInClass = 'top';
                                slideOutTop = -$currentIframe.height() - 30;
                            }
                        break;
                        case 'next':
                            $nextIframe = $nextIframe.next('iframe');
                            if (direction == 'horizontal') {
                                slideOutClass = 'left';
                                slideInClass = 'right';
                            } else if (direction == 'vertical') {
                                slideOutClass = 'top';
                                slideInClass = 'bottom';
                                slideOutTop = $currentIframe.height() + 30;
                            }
                        break;
                        default: break;
                    }

                    $currentIframe.removeClass('active').addClass('middle');
                    $nextIframe.removeClass(slideInClass).addClass('middle');
                    $currentIframe.removeClass('middle').addClass(slideOutClass).css({'top':slideOutTop});

                    $content.append($placeholder.height($currentIframe.height()).css('margin', '0'));
                    $placeholder.height($nextIframe.outerHeight(true));

                    $nextIframe.css({'visibility': ''});
                    $currentIframe.one(this.transitionEvent, function () {
						$iframes.removeClass('left right top bottom');
						$currentIframe.css({'display': '', 'height': 'auto'});
						var slideEnd = setTimeout(function() {
							$iframes.removeClass('middle');
							$nextIframe.addClass('active');
							$placeholder.remove();
						},50);
					});
                    
                } else {
                    console.log("direction must be horizontal or vertical and action must be prev or next");
                }
            }
        }.bind(this);

        // Initialization
        this.toggle();

/*        if ( this.iframeMode ) {
            console.log('Initialization in iframeMode');
            this.isLoadingIframe = true;
            this.$iframe.attr("src", this.options.iframe);
            this.$iframe.attr("scrolling", "no");
            this.$iframe.addClass('active');
            this.iframeEventListener(true);

            this.transitionEvent = function (transitions){
				var t, el = document.createElement("fakeelement");
				for (t in transitions){
					if (el.style[t] !== undefined){
						return transitions[t];
					}
				}
			}({
				"transition": "transitionend",
				"OTransition": "oTransitionEnd",
				"MozTransition": "transitionend",
				"WebkitTransition": "webkitTransitionEnd"
			});


        }*/
    };

    Modal.TRANSITION_DURATION = 300;
    Modal.BACKDROP_TRANSITION_DURATION = 150;

    Modal.DEFAULTS = {
        iframe: null,
        backdrop: true,
        keyboard: true,
        show: true,
        bodyScroll: false,
        bodyMaxHeight: $(window).height() * 0.75,
        fullscreenonmobile: false, // 為行動裝置時是否預設填滿視窗
        reloadwhenopen: false,
        iframeSendToChild: {
            hello: {
                docWidth: document.documentElement.clientWidth
            },
            load: {},
            check: {},
            close: function() {}
        },
        whenShowModalStart: function( $modal, iframe ) {
            // console.log( 'whenShowModalStart', $modal, iframe );
        },
        whenShowModalEnd: function( $modal, iframe ) {
            // console.log( 'whenShowModalEnd', $modal, iframe );
        },
        whenHideModalStart: function( $modal, iframe ) {
            // console.log( 'whenHideModalStart', $modal, iframe );
        },
        whenHideModalEnd: function( $modal, iframe ) {
            // console.log( 'whenHideModalEnd', $modal, iframe );
        }
    };

    Modal.prototype.showAfterLoaded = function() {
        console.log("run showAfterLoaded");
        this.isloading = true;
        this.$element.find('.modal-content').load(this.options.remote, $.proxy(function() {
            this.$element.trigger('loaded.modal');
            this.remoteFirstLoaded = true;
            this.isloading = false;
            this.show();
        }, this)) 
    };

    Modal.prototype.toggle = function(_relatedTarget) {
        console.log('run toggle');
        /*if (this.options.reloadwhenopen) {
            if(!this.maskIsOpen && !this.isShown) {        
                this.isloading = true;             
                this.showAfterLoaded()
            }
        } else {
            this.isShown ? this.hide() : this.show(_relatedTarget)            
        }*/
        if ( this.isShown ) {
            this.hide();
        } else {
            if ( this.options.remote ) {
                if ( !this.isloading ) {
                    if ( this.options.reloadwhenopen || !this.remoteFirstLoaded ) {
                        this.showAfterLoaded();
                    } else {
                        this.show(_relatedTarget);
                    }
                } else {
                    console.log('This Modal is already loading');
                }
            } else {
                this.show(_relatedTarget);
            }
        }
    };

    Modal.prototype.setIframeSrc = function( indexOf ) {
        // console.log('run setIframeSrc');
        var whichIframe = indexOf || 0;
        if ( typeof whichIframe === 'number' ) {
            this.$element.find('iframe').first().attr('src', this.options.iframe);
            this.iframeEventListener(true);
        } else {
            console.log('The `indexOf` type of param must be number');
        }
    };

    Modal.prototype.setEventWhenShow = function() {
        var self = this;

        this.$element.on('click.dismiss.modal', '[data-dismiss="mdl_lnls"]', $.proxy(this.hide, this));

        this.$dialog.on('mousedown.dismiss.modal', function() {
            // console.log('mousedown.dismiss.modal');
            self.$element.one('mouseup.dismiss.modal', function(e) {
                // console.log('mouseup.dismiss.modal');
                if ($(e.target).is(self.$element)) self.ignoreBackdropClick = true;
            });
        });

        this.$element.on('click.move.content', '[data-move="mdl_lnls"]', $.proxy(function(e) {
            var $trigger = $(e.target);
            var nextprev = $trigger.attr('data-step');
            this.contentMove(nextprev);
        }, this));
    };

    Modal.prototype.removeEventWhenHide = function() {
        this.$element.off('click.dismiss.modal').off('mouseup.dismiss.modal').off('click.move.content');
        this.$dialog.off('mousedown.dismiss.modal');
    };

    Modal.prototype.show = function(_relatedTarget) {
        console.log('run show!');
        var that = this;        
        var e = $.Event('show.modal', { relatedTarget: _relatedTarget });        
        this.$element.trigger(e);   
        // if ( !this.isShown || !e.isDefaultPrevented() ) {
        this.isShown = true;
        this.checkScrollbar();
        this.setScrollbar();

        this.escape();
        this.resize();
        this.setIframeSrc();

        this.$body.addClass('mdl_lnls_open');
        this.$element.find('iframe').first().addClass('active');

        this.setEventWhenShow();
        if (this.isMove === true) {
            this.$contents.addClass('hide');
            var $initAcitve = this.$contents.filter('.active');
            if (!!$initAcitve.length && $initAcitve.length == 1) {
                $initAcitve.removeClass('hide');
            } else {
                this.$contents.eq(0).addClass('active').removeClass('hide');
            }
        }
        if ( $.type(this.options.whenShowModalStart) === 'function' ) {
            this.options.whenShowModalStart( this.$element, this.iframeContent );
        }
        this.backdrop(function() {
            // console.log(this, _relatedTarget);
            var transition = $.support.transition && that.$element.hasClass('fade');
            // console.log('backdrop callback', that.$backdrop);
            if (!that.$element.parent().length) {
                that.$element.appendTo(that.$body);
            }
            that.$element.show().scrollTop(0);

            that.adjustDialog();

            if (transition) {
                that.$element[0].offsetWidth; // force reflow
            }
            that.$element.addClass('in');
            that.enforceFocus();

            var e = $.Event('shown.modal', { relatedTarget: _relatedTarget });
            // 行動裝置時內容要有scroll bar
            if ( $.browser.mobile ) {
                // console.log(that.$ctnBody);
                if ( that.$ctnFoot.length > 0 && that.$ctnBody.hasClass('scroll-y') && document.documentElement.clientWidth < 980 ) {
                    that.$ctnBody.css('max-height', that.options.bodyMaxHeight);
                    that.$contents.append('<div class="content-fadeout"></div>');
                    that.$contents.find('.content-fadeout').css({'bottom': that.$ctnFoot.outerHeight()});
                }
            }

            if ( transition ) {
                that.$dialog.one('bsTransitionEnd', function() {
                    that.$element.trigger('focus').trigger(e);
                    if ( $.type(that.options.whenShowModalEnd) === 'function' ) {
                        that.options.whenShowModalEnd( that.$element, that.iframeContent );
                    }
                }).emulateTransitionEnd(Modal.TRANSITION_DURATION);
            } else {
                that.$element.trigger('focus').trigger(e);
                if ( $.type(that.options.whenShowModalEnd) === 'function' ) {
                    that.options.whenShowModalEnd( that.$element, that.iframeContent );
                }
            }
            // console.log("end")
        });
        // }
    };

    Modal.prototype.hide = function(e) {
        if (e) {
            e.preventDefault();
        }

        e = $.Event('hide.modal');

        this.$element.trigger(e);

        if (!this.isShown || e.isDefaultPrevented()){
            return;
        }
        this.isShown = false;

        this.escape();
        this.resize();

        this.unforceFocus();
        this.removeEventWhenHide();

        this.$element.removeClass('in');

        this.$dialog.off('mousedown.dismiss.modal')

        if ( $.type(this.options.whenHideModalStart) === 'function' ) {
            this.options.whenHideModalStart( this.$element, this.iframeContent );
        }
        if ( $.support.transition && this.$element.hasClass('fade') ) {
            this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION);
        } else {
            this.hideModal();
        }

        $(window).off("resize");
        
        // redirect if have attr: data-redirectwhenclose
        var redirectURL = this.$element.attr("data-redirectwhenclose");
        !!redirectURL && (window.location = redirectURL);
    }

    Modal.prototype.nextMover = function() {
        this.contentMove('next');
    }

    Modal.prototype.prevMover = function() {
        this.contentMove('prev');
    }

    Modal.prototype.contentMove = function(nextprev) {
        if (!nextprev) {
            console.log('plz assign option or ues nextMover and prevMover Methdos');
            return;
        }
        var targetDirection = nextprev; // next, prev
        var that = this;
        this.canSwicth(targetDirection, function(recource) {
            // console.log(recource);
            var $this = recource.$contentActive;
            var $next = recource.$contentNext;
            var $holder = $('<div class="placeholder"></div>');
            $holder.css({
                width: $this.outerWidth(),
                height: $this.outerHeight()
            });
            that.$dialog.children('.modal-wrap').append($holder);
            var thisContentClass = function() {
                if (targetDirection == 'prev') {
                    if (recource.direction == 'vertical') {
                        return 'bottom';
                    } else {
                        return 'right';
                    }
                } else {
                    if (recource.direction == 'vertical') {
                        return 'top';
                    } else {
                        return 'left';
                    }
                }
            }();
            var nextContentClass = function() {
                if (targetDirection == 'prev') {
                    if (recource.direction == 'vertical') {
                        return 'top';
                    } else {
                        return 'left';
                    }
                } else {
                    if (recource.direction == 'vertical') {
                        return 'bottom';
                    } else {
                        return 'right';
                    }
                }
            }();
            $this.addClass('middle').removeClass('active').delay(1).queue(function() {
                that.$element.trigger('move.start');
                $this.removeClass('middle').addClass(thisContentClass).one('bsTransitionEnd', function() {
                    $this.addClass('hide').removeClass(thisContentClass);

                });
                $holder.css({
                    width: $next.outerWidth(),
                    height: $next.outerHeight()
                });

                $(this).dequeue();
            });
            $next.removeClass('hide').addClass(nextContentClass).delay(1).queue(function() {

                $next.removeClass(nextContentClass).addClass('middle').one('bsTransitionEnd', function() {
                    $next.addClass('active').removeClass('middle');
                    $holder.remove();
                    that.$element.trigger('move.done');
                });
                $(this).dequeue();
            });

            that.$element.one('hidden.modal', function() {
                $holder.remove();
            });
        });

    }

    Modal.prototype.canSwicth = function(direction, callback) {
        if (this.$contents.length > 1) {
            var $nowActive = this.$contents.filter('.active');
            var nowIndex = this.$contents.index($nowActive);
            if (direction == 'next') {
                var nextIndex = nowIndex + 1;
                (nextIndex >= this.$contents.length) && (nextIndex = 0);
            } else if (direction == 'prev') {
                var nextIndex = nowIndex - 1;
            }
            var $nextContent = this.$contents.eq(nextIndex);
            if (typeof callback === 'function') {
                var obj = {
                    $contentActive: $nowActive,
                    $contentNext: $nextContent,
                    direction: $nextContent.attr('data-direction') || 'horizontal' // horizontal or vertical
                };
                callback(obj);
            }
            return true;
        } else {
            console.log('this modal can\'t supported content switch');
            return false;
        }
    }

    Modal.prototype.enforceFocus = function() {
        $(document)
            .off('focusin.modal') // guard against infinite focus loop
            .on('focusin.modal', $.proxy(function(e) {
                if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
                    this.$element.trigger('focus')
                }
            }, this))
    }

    Modal.prototype.unforceFocus = function() {
        $(document).off('focusin.modal');
    };

    Modal.prototype.escape = function() {
        if (this.isShown && this.options.keyboard) {
            this.$element.on('keydown.dismiss.modal', $.proxy(function(e) {
                e.which == 27 && this.hide()
            }, this))
        } else if (!this.isShown) {
            this.$element.off('keydown.dismiss.modal')
        }
    }

    Modal.prototype.resize = function() {
        if (this.isShown) {
            $(window).on('resize.modal', $.proxy(this.handleUpdate, this))
        } else {
            $(window).off('resize.modal')
        }
    }

    Modal.prototype.hideModal = function() {
        var that = this;
        this.$element.hide();
        this.backdrop(function() {
            that.$body.removeClass('mdl_lnls_open');
            that.resetAdjustments();
            that.resetScrollbar();
            that.$element.trigger('hidden.modal');
        });
        if ( $.type(this.options.whenHideModalEnd) === 'function' ) {
            this.options.whenHideModalEnd( this.$element, this.iframeContent );
        }
        if (this.options.iframe) {
        	this.iframeEventListener(false);
            this.$element.find('iframe').removeClass('active').css('display', '');
        }
    }

    Modal.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove()
        this.$backdrop = null
    }

    Modal.prototype.backdrop = function(callback) {
        var that = this
        var animate = this.$element.hasClass('fade') ? 'fade' : ''
        var mobilePage = $.browser.mobile ? '' : ''

        if (this.isShown && this.options.backdrop) {
            var doAnimate = $.support.transition && animate
            if (this.options.backdrop == "transparent" || this.$element.hasClass('alert')) {
                this.$backdrop = $(document.createElement('div')).addClass('mdl_lnls_backdrop_transparent ' + animate).appendTo(this.$body);
            } else {
                this.$backdrop = $(document.createElement('div')).addClass('mdl_lnls_backdrop ' + animate + ' ' + mobilePage).appendTo(this.$body);
            }

            this.$element.on('click.dismiss.modal', $.proxy(function(e) {
                if (this.ignoreBackdropClick) {
                    this.ignoreBackdropClick = false
                    return
                }
                if (e.target !== e.currentTarget) return
                this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide()
            }, this))
            this.$element.on('close', $.proxy(function(e) {
                if (this.ignoreBackdropClick) {
                    this.ignoreBackdropClick = false
                    return
                }
                if (e.target !== e.currentTarget) return
                this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide()
            }, this))
            if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

            this.$backdrop.addClass('in');

            if (!callback) return

            if (doAnimate) {
                this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION);
            } else {
                callback();
            }
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass('in')
            var callbackRemove = function() {
                that.removeBackdrop()
                callback && callback()
            }
            $.support.transition && this.$element.hasClass('fade') ?
                this.$backdrop
                .one('bsTransitionEnd', callbackRemove)
                .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
                callbackRemove();
        } else if ( $.type(callback) === 'function' ) {
            callback();
        }
    }

    // these following methods are used to handle overflowing modals

    Modal.prototype.handleUpdate = function() {
        this.adjustDialog()
    }

    Modal.prototype.adjustDialog = function() {
        var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
        
        // 為行動裝置時設定是否要填滿整個視窗
        if ($.browser.mobile && this.options.fullscreenonmobile == true) {
            this.$dialog.css('height', '100%');
            this.$dialog.find(".modal-wrap").css( 'height', '100%'); 
            this.$contents.css('minHeight', '100%');
        }
        this.$element.css({
            //paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
            paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
        })
    }

    Modal.prototype.resetAdjustments = function() {
        this.$element.css({
            paddingLeft: '',
            paddingRight: ''
        })
    }

    Modal.prototype.checkScrollbar = function() {
        var fullWindowWidth = window.innerWidth
        if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
            var documentElementRect = document.documentElement.getBoundingClientRect()
            fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
        }
        this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
        this.scrollbarWidth = this.measureScrollbar()
    }

    Modal.prototype.setScrollbar = function() {
        var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
        this.originalBodyPad = document.body.style.paddingRight || ''
        if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
    }

    Modal.prototype.resetScrollbar = function() {
        this.$body.css('padding-right', this.originalBodyPad)
    }

    Modal.prototype.measureScrollbar = function() { // thx walsh
        var scrollDiv = document.createElement('div')
        scrollDiv.className = 'mdl_lnls_scrollbar_measure'
        this.$body.append(scrollDiv)
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
        this.$body[0].removeChild(scrollDiv)
        return scrollbarWidth
    }

    // ========== iframe settings =================================
    Modal.prototype.iframeEventListener = function(setListener) {
        if (setListener) {
            console.log("iframe event listening!");
            window.addEventListener("message", this.iframePostEvents, false);
        } else {
            console.log("iframe event stop listening!");
            window.removeEventListener("message", this.iframePostEvents, false);
        }
    }
    // ========== iframe settings end =============================

    // MODAL PLUGIN DEFINITION
    // =======================

    function Plugin(option, _relatedTarget) {
        return this.each(function() {
            var $this = $(this)
            var module = $this.data('modal')
            var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
            if (true) {}
            if ( !module ) {
                $this.data('modal', (module = new Modal(this, options)));
            } else if ( typeof option === 'string' ) {
                module[option](_relatedTarget);
            } else if (options.show) {
                console.log('options.show', options.show);
                module.show(_relatedTarget);
            }
        })
    }

    var old = $.fn.mdl_lnls

    $.fn.mdl_lnls = Plugin
    $.fn.mdl_lnls.Constructor = Modal


    // MODAL NO CONFLICT
    // =================

    $.fn.mdl_lnls.noConflict = function() {
        $.fn.mdl_lnls = old
        return this
    }


    // MODAL DATA-API
    // ==============
    $(document).on('click.modal.data-api', '[data-toggle="mdl_lnls"]', function(e) {
        var $this = $(this)
        var href = $this.attr('href');
        var $target = function(){
            var mdl_lnls_target = $this.attr('data-mdl_lnls_target');
            var target = $this.attr('data-target');
            var hrefstring = href && href.replace(/.*(?=#[^\s]+$)/, '');
            var returnValue;
            if ( typeof mdl_lnls_target === 'string' && mdl_lnls_target.length > 0 ) {
                returnValue = $(mdl_lnls_target);
            } else if ( typeof target === 'string' && target.length > 0 ) {
                returnValue = $(target);
            } else {
                returnValue = hrefstring;
            }
            return returnValue;
        }();
        var $iframe = $this.attr('data-iframe') ? $this.attr('data-iframe') : false;          
            if ( $target.data('modal') ) {
                var option = 'toggle';
                var targetOpts =  $target.data('modal').options;
                targetOpts.reloadwhenopen && (targetOpts.remote = !/#/.test(href) && href);
            } else {
                var option = $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data(), { iframe: $iframe});                
            }

            if ($this.is('a')) e.preventDefault()

            $target.one('show.modal', function(showEvent) {            
                if (showEvent.isDefaultPrevented()) return
                $target.one('hidden.modal', function() {
                    $this.is(':visible') && $this.trigger('focus')
                })
            })
            Plugin.call($target, option, this)            
    })

})(jQuery);



// WEBPACK FOOTER //
// ./magaele/mdl_lnls/module.js